module.exports = __webpack_public_path__ + "img/logo 1.86aaa1e9.png";